import { DefaultThunkAction } from "@/redux/util/type";
import axios from "axios";
import {
	setOrganizationInfoFetchFail,
	setOrganizationInfoFetchRequest,
	setOrganizationInfoFetchSuccess,
} from "@/redux/organization/actions";
import API from "@/api/serverCall";
import { CurrentPlanType } from "@/redux/organization/types";
import { setIsLoading } from "@/redux/global/actions";
import {
	AppResponseDto,
	CompanyInfoCtlDto,
	CompanyResponseDto,
	DashboardCtlDto,
} from "@/api/interface";
import { openErrorSnackbar } from "@/redux/notistack/actions";

export default function getOrganizationInfoRequestThunk(): DefaultThunkAction {
	return async (dispatch) => {
		dispatch(setIsLoading(true));
		dispatch(setOrganizationInfoFetchRequest());
		try {
			const { data: currentPlan } = await API.get<CurrentPlanType>({
				link: "/payment/current",
			});

			const { data: companyInfo } = await API.get<CompanyResponseDto>({
				link: "/company",
			});

			const { data: companyDetailInfo } = await API.get<CompanyInfoCtlDto>({
				link: "/companyInfo",
			});

			const { data: dashboardInfo } = await API.get<DashboardCtlDto>({
				link: "/dashboard",
			});

			const { data: applicationInfo } = await API.get<AppResponseDto[]>({
				link: "/app",
			});

			dispatch(
				setOrganizationInfoFetchSuccess({
					currentPlan,
					companyInfo,
					companyDetailInfo,
					dashboardInfo,
					applicationInfo,
				}),
			);
			dispatch(setIsLoading(false));
		} catch (e) {
			dispatch(setOrganizationInfoFetchFail());
			if (axios.isAxiosError(e)) {
				dispatch(setIsLoading(false));
				dispatch(openErrorSnackbar("정보를 불러오지 못했습니다"));
			}
		}
	};
}
